module.exports = __webpack_public_path__ + "images/illos.abe6b994293eac4d9da6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/illos.png
// module id = tqqe
// module chunks = 24